import { defineAsyncComponent } from 'vue'

interface PageTypeConfig {
  component: Component
  prop?: string
}

const registry: Record<string, PageTypeConfig> = {
  VW: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/DeliveryContent.vue')) },
  DC: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/DisclaimerCopyright.vue')) },
  HP: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/HelpPage.vue')) },
  WP: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/WhitePaperPage.vue')) },
  IT: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/PhoneBook.vue')) },
  NA: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/NewsLetterRegistration.vue')) },
  NI: { component: defineAsyncComponent(() => import('@/components/News/newsItemComponent.vue')), prop: 'news' },
  EV: { component: defineAsyncComponent(() => import('@/components/Events/eventComponent.vue')), prop: 'events' },
  AC: { component: defineAsyncComponent(() => import('@/components/Action/actionComponent.vue')), prop: 'action' },
  RE: { component: defineAsyncComponent(() => import('@/components/Reference/referenceComponent.vue')), prop: 'reference' },
  DN: { component: defineAsyncComponent(() => import('@/components/News/newsOverview.vue')) },
  DE: { component: defineAsyncComponent(() => import('@/components/Events/eventOverview.vue')) },
  DA: { component: defineAsyncComponent(() => import('@/components/Action/actionsOverview.vue')) },
  DR: { component: defineAsyncComponent(() => import('@/components/Reference/referencesOverview.vue')) },
  IP: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/IndexPage.vue')) },
  NF: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/NotFoundPage.vue')) },
  MD: { component: defineAsyncComponent(() => import('@/components/Contact/contactDetailInformation.vue')) },
  ML: { component: defineAsyncComponent(() => import('@/components/Contact/contactInformation.vue')) },
  PD: { component: defineAsyncComponent(() => import('@/components/Products/Details/productDetail.vue')) },
  WW: { component: defineAsyncComponent(() => import('@/layers/checkout/components/Cart/CartPage.client.vue')) },
  WB: { component: defineAsyncComponent(() => import('@/layers/checkout/components/Checkout/CheckoutPage.client.vue')) },
  IL: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/LiveViewer.vue')) },
  FC: { component: defineAsyncComponent(() => import('@/layers/vacancies/components/OpenApplication.vue')) },
  PS: { component: defineAsyncComponent(() => import('@/components/Products/ProductOverview.vue')) },
  PM: { component: defineAsyncComponent(() => import('@/components/Products/ProductOverview.vue')) },
  ES: { component: defineAsyncComponent(() => import('@/components/Products/ProductOverview.vue')) },
  RESET_PASSWORD: { component: defineAsyncComponent(() => import('@/layers/checkout/components/Auth/NewPasswordPage.client.vue')) },
  StaticText: { component: defineAsyncComponent(() => import('@/components/OurPages/Pages/StaticText.vue')) },
}

export function getPageComponent(pageType: string): Component | null {
  return registry[pageType]?.component ?? registry['StaticText']?.component ?? null
}

export function getPagePropName(pageType: string): string {
  return registry[pageType]?.prop ?? 'pageItem'
}
